export class TripPeriodPrice {
  public id?: number;
  public startTime: number;
  public endTime: number;
  public priceCents: number;
  public timeUnit: number;


  serealize(trip: TripPeriodPriceForm) {
    this.id = trip.id;
    this.startTime = this.formatTime(trip.startTimeH, trip.startTimeM);
    this.endTime = this.formatTime(trip.endTimeH, trip.endTimeM);
    this.priceCents = trip.priceCents;
    this.timeUnit = trip.timeUnit;
    return this;
  }

  private formatTime(h: number, m: number) {
    const seconds = (h * 60 * 60) + (m * 60);
    return seconds;
  }

}

export class TripPeriodPriceForm {
  id?: number;
  startTimeH: number;
  startTimeM: number;
  endTimeH: number;
  endTimeM: number;
  priceCents: number;
  timeUnit: number;

  constructor(trip: TripPeriodPrice) {
    this.deserealize(trip);
  }

  private deserealize(trip: TripPeriodPrice) {
    this.id = trip.id;
    this.priceCents = trip.priceCents;
    this.timeUnit = trip.timeUnit;
    const [startTimeH, startTimeM] = this.formartTime(trip.startTime);
    const [endTimeH, endTimeM] = this.formartTime(trip.endTime);
    this.startTimeH = startTimeH;
    this.startTimeM = startTimeM;
    this.endTimeH = endTimeH;
    this.endTimeM = endTimeM;
  }

  formartTime(seconds: number) {
    const h = Math.floor(seconds / 3600);
    const m = Math.floor(seconds % 3600 / 60);
    return [h, m];
  }
}



// WEBPACK FOOTER //
// ./src/app/models/trip-period-price.ts